import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Forbidden: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Result
      status="403"
      title="403"
      subTitle={t('errors.403')}
      extra={
        <Button type="primary" onClick={() => navigate('/dashboard')}>
          {t('errors.backToHome')}
        </Button>
      }
    />
  );
};

export default Forbidden;
